import React from 'react';
import { Box } from '@mui/material';


export type IBody = {
    children?: React.ReactNode,
}

const css = {
    main: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        padding: '88px 24px 24px 24px',
        minHeight: '100vh',
        maxWidth: '100%',
        overflow: 'hidden',
    },
}

export default function Body({ children }: IBody) {

    return (
        <Box component="main" sx={css.main}>
            {children}
        </Box>
    );
}; 